import { render, staticRenderFns } from "./OrganizationUserCard.vue?vue&type=template&id=4ee6c8cd&scoped=true&"
import script from "./OrganizationUserCard.vue?vue&type=script&lang=ts&"
export * from "./OrganizationUserCard.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationUserCard.vue?vue&type=style&index=0&id=4ee6c8cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee6c8cd",
  null
  
)

export default component.exports